import { IInitMessage } from '@interfaces/streaming';
import axios from 'axios';
import { env } from 'env';

interface StreamSessionData {
  gameName: string;
  description: string;
  participantId: string;
  websocketSessionId: string;
  signalRequest: string;
  timeout: number;
  streamId: string;
  initMessage: IInitMessage;
  region: string;
  launchArgs: string[] | null;
  sessionKey?: string;
}

interface StreamGroupIdResponse {
  eventId: string;
  streamGroupId: string;
  region: string;
}

interface IConnectToStreamSessionResponse {
  signalResponse: string;
}

export default class GameCastService {
  static async startGameSession({
    gameName,
    description,
    participantId,
    websocketSessionId,
    signalRequest,
    timeout,
    streamId,
    initMessage,
    region,
    launchArgs,
    sessionKey,
  }: StreamSessionData): Promise<void> {
    return axios
      .post(
        `${env.REACT_APP_API_URL}api/v2/gamecast/stream-session/new`,
        {
          gameName,
          description,
          participantId,
          websocketSessionId,
          signalRequest,
          timeout,
          streamGroupId: streamId,
          initMessage,
          region,
          additionalLaunchArgs: [
            '-PixelStreamingDecoupleFramerate=true',
            '-PixelStreamingCaptureUseFence=true',
            ...(launchArgs || []),
          ],
          sessionKey,
        },
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      )
      .then((res) => res.data);
  }

  static getGameSessionId(eventId: string): Promise<StreamGroupIdResponse> {
    return axios
      .get(`${env.REACT_APP_API_URL}api/v2/gamecast/${eventId}`)
      .then((res) => res.data);
  }

  static async connectToStreamSession(sessionId: string, data: any): Promise<IConnectToStreamSessionResponse | null> {
    return axios
      .post(`${env.REACT_APP_API_URL}api/v2/gamelift-streams/sessions/${sessionId}/connect`, data)
      .then((res) => res.data);
  }
}
